/**
 *   Import
 *   - Libraies
 */
import * as React from 'react'
import glamorous from 'glamorous'
import { InjectedFormikProps } from 'formik'

/**
 *   Import
 */
import { Props } from '../../pages/Forgot/Forgot'
import { Values } from '../../../containers/pages/ForgotForm/ForgotForm'

/**
 *   Import
 *   - UI Components
 */
import { Alert } from '../Alert/Alert'
import { Input } from '../Input/Input'
import { SubmitButton } from '../SubmitButton/SubmitButton'
import { FormTitle } from './components/FormTitle/FormTitle'
import { LinkButton } from './components/LinkButton/LinkButton'
import { Form } from './components/Form/Form'
import { StyledForgotForm, StyledForgotMessage, StyledForgotSuccessMessage } from './ForgotForm.glamorous'

/**
 *   CSS Styles
 */
export const StyledInput = glamorous(Input)({
    padding: '0 80px 20px',
})

export const LastStyledInput = glamorous(StyledInput)({
    padding: '0 80px 40px',
})

export const ForgotForm: React.SFC<InjectedFormikProps<Props, Values>> = (props) => {
    if (!props.forgotStatus) {
    return (
        <StyledForgotForm>

            <FormTitle>Forgot password</FormTitle>

            {(!!Object.keys(props.errors).length && !!Object.keys(props.touched).length) && (
                Object.keys(props.errors).filter(msg => Object.keys(props.touched).includes(msg)).map((error, idx) => {
                    const msg = props.errors[error]
                    return (
                        <Alert type="error">
                        <p key={`${error}${idx}`}>{`${msg.charAt(0).toUpperCase()}${msg.slice(1)}`}</p>
                        </Alert>
                    )
                })
            )}

            {(props.userError !== '') ? (<Alert type="error"><p key={0}>{`${props.userError}`}</p></Alert>) : null}

            <Form onSubmit={props.handleSubmit}>
                <StyledForgotMessage>
                    Please enter the email associated with your account,
                    password reset instructions will be sent to you.
                </StyledForgotMessage>
                <StyledInput
                    error={props.touched.email && props.errors.hasOwnProperty('email')}
                    id="email"
                    label="Email"
                    onBlur={props.handleBlur}
                    onChange={props.handleChange}
                    placeholder="test@test.com"
                    required={true}
                    tabIndex={1}
                    type="email"
                    value={props.values.email}
                    onFocus={props.handleBlur}
                />

                <SubmitButton
                    disabled={!props.isValid || props.isSubmitting}
                    type="submit"
                >
                  Submit
                </SubmitButton>
            </Form>
        </StyledForgotForm>
    )
    }else {
        return(
            <StyledForgotForm>

                <FormTitle>Check your email</FormTitle>

                <Form>
                    <StyledForgotSuccessMessage>
                        Thank you, we have sent you an email with instructions for resetting your password.
                    </StyledForgotSuccessMessage>
                </Form>

                <LinkButton url={'/login'}>Login</LinkButton>

            </StyledForgotForm>
        )
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/ForgotForm/ForgotForm.tsx